import { FormMemberResponse } from 'src/modules/member/models/formMemberResponse';
import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'FormSetting';

export interface FormSettingField {
  formSettingsID: number;
  productID: number;
  formName: string;
  fieldName: string;
  heading: string;
  show: boolean;
  required: boolean;
  locked: boolean;
  type: number;
  extra: string;
  extraOptions?: { name: string; value: string }[];
  validator: string;
  errorMessage: string;
  fieldSize: number;
  row: number;
  col: number;
  groupID: number;
  groupName: string;
}

export interface FormSettingFieldRequest {
  fieldName: string;
  heading: string;
  show: boolean;
  required: boolean;
  locked: boolean;
  type: number;
  extra: string;
  validator: string;
  errorMessage: string;
  fieldSize: number;
  row: number;
  col: number;
}

export const getFormSettingFields = (formName: string) => {
  return AxiosInstance.get<FormSettingField[]>(`${controller}/${formName}/Fields`);
};

export const createFormSettingField = (formName: string, data: FormSettingFieldRequest) => {
  return AxiosInstance.post<number>(`${controller}/${formName}/Fields`, data);
};

export const updateFormSettingField = (formName: string, id: number, data: FormSettingFieldRequest) => {
  return AxiosInstance.put(`${controller}/${formName}/Fields/${id}`, data);
};

export const deleteFormSettingField = (formName: string, id: number) => {
  return AxiosInstance.delete(`${controller}/${formName}/Fields/${id}`);
};

export const getFormSettingPreview = (formName: string) => {
  return AxiosInstance.get<FormMemberResponse>(`${controller}/${formName}/Preview`);
};
